<template>
  <template></template>
</template>

<script>
import EstilizacaoGlobal from './EstilizacaoGlobal.js'
export default EstilizacaoGlobal
</script>

<style>
.espacamento-pdf {
  padding: 0 15px;
}

.icone-global-imagemfundo{
  max-height: 500px;
  margin-top: 2rem;
}

.texto-padrao-imagemfundo {
  font-size: 1.2rem;
  color: #4f4c4d;
  text-align: center;
  font-family: 'Montserrat';
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}


.gama-popup{
  --border-radius-grau: 1rem
}

div.p-dialog-mask .gama-popup.p-dialog .p-dialog-header {
  background: var(--amarelo-principal) !important;
  padding: 1.5rem;
  border-radius: var(--border-radius-grau) var(--border-radius-grau) 0 0;
}

div.p-dialog-mask .gama-popup.p-dialog .p-dialog-content{
  border-radius: 0 0 var(--border-radius-grau) var(--border-radius-grau);
}

div.gama-popup.p-dialog{
  border-radius: 2rem;
}

div.p-dialog-mask .gama-popup-simples.p-dialog .p-dialog-header{
  border-radius: 2rem 2rem 0 0 !important;
}

div.p-dialog-mask .gama-popup-simples.p-dialog .p-dialog-content{
  border-radius: 0 0 2rem 2rem !important;
}

div.gama-popup-simples.p-dialog{
  border-radius: 2rem;
}

.unidade.p-dropdown span.p-dropdown-label.p-placeholder{
  justify-content: center !important;
  color: #495057 !important;
}


.tipo.p-dropdown span.p-dropdown-label.p-placeholder{
  justify-content: center !important;
  color: #495057 !important;
}

.unidade span.p-dropdown-label.p-inputtext{
  text-align: center !important;
}

.filtro-titulo {
  color: #4f2c19;
  text-align: left;
  font-weight: bold;
  align-self: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

}

/* .filtro-label{
  font-size: 14px;
  color: #747474;
  text-align: left;
  font-family: Montserrat;
  font-weight: bold;
  padding: 5px 0;
} */

.fonte-padrao{
  text-align: left !important;
  font-family: 'Montserrat' !important;
}

@media (min-width:310px) {

.filtro-label {
  color: #4F4C4D !important;
  text-align: left !important;
  font-size: 14px !important;
  font-family: 'Montserrat' !important;
  font-weight: bold !important;
  padding: 5px 0 !important;
}

.filtro-titulo{
    font-size: 18px;
  }
}

@media (min-width: 368px) {

  .filtro-titulo{
    font-size: 18px;
  }

  .icone-global-imagemfundo{
    min-width: 80%;
  }
}

@media (min-width: 600px) {

  .filtro-titulo{
    font-size: 20px;
  }

  .icone-global-imagemfundo{
    min-width: 70%;
  }
}

@media (min-width: 801px) {
  .grid-filtro {
    margin: 20px 20px 0 20px !important;
  }

  .filtro-titulo{
    font-size: 22px;
  }

  .icone-global-imagemfundo{
    min-width: 50%;
  }
}

/* @media (min-width: 1025px) {
  .filtro-titulo{
    font-size: 22px;
  }
} */

/* @media (max-width: 1281px) {
  .icone-global-imagemfundo{
    max-height: 500px;
    min-width: 100%;
  }
} */

@media (min-width:1025px) {
.icone-global-imagemfundo{
    min-width: 30%;
  }
}

@media (min-width: 1281px) {
  .icone-global-imagemfundo{
    /* margin: 0 25%; */
    max-height: 500px;
  }
}


/* NOVAS CLASSES GLOBAIS */
/* CARD CABEÇALHO */
.header-filtros {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.header-icons {
  display: flex;
  flex-direction: row;
  column-gap: 12px;
}

.header-detalhes-secundario {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2,auto);
  justify-content: space-between;
  align-items: baseline;
  padding: 20px 0 15px;
  border-bottom: 1px solid #f0f0f0;
}

.header-detalhes-secundario-titulo {
  display: grid;
  grid-template-columns: repeat(2, auto);
  align-items: center;
}

.header-gerenciamento {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  padding: 20px 0 15px;
}

.header-button-titulo-gerenciamento {
  display: flex;
}

/* TÍTULOS E LABELS */
.cabecalho-formulario {
  padding: 20px 10px 10px;
  border-bottom: 1px solid #f0f0f0;
}

.titulo-formulario {
  color: #4f2c19;
  text-align: left;
  font-size: 21px;
  font-family: "MontSerrat";
  font-weight: bold;
}

.titulo-grupo-formulario {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 500;
  padding: 10px 0 10px;
  margin-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
}

.titulo-filtros-cabecalho {
  color: #4f2c19;
  text-align: left;
  font-weight: bold;
  font-family: "MontSerrat";
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.titulo-conteudo-filtros {
  width: 100%;
  color: #3e3e3e;
  text-align: left;
  font-size: 15px;
  font-family: "MontSerrat";
  font-weight: bold;
  margin: 10px 0 0.3rem;
}

.titulo-detalhes-cabecalho {
  color: #4f4c4d;
  text-align: left;
  font-size: 20px;
  font-family: "MontSerrat";
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.titulo-grupo-detalhes {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  padding: 30px 0 10px;
  border-bottom: 1px solid #f0f0f0;
}

.titulo-conteudo-detalhes {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 700;
  margin-top: 15px;
}

.label-conteudo {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  margin-bottom: 10px;
}

.titulo-inicio-fluxos, .titulo-fluxos {
  color: #4f2c19;
  font-family: "MontSerrat";
  font-weight: bold;
  align-self: center;
}

.subtitulo-fluxos {
  color: #8a8a8a;
  font-size: 16px;
  font-family: "MontSerrat";
  padding: 10px;
  margin-bottom: 10px;
  /* width:50%; */
  text-align: center;
}

.titulo-conteudo-fluxos {
  width: 100%;
  color: #3e3e3e;
  text-align: left;
  font-size: 15px;
  font-family: "MontSerrat";
  font-weight: bold;
  margin: 0 0 1px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.titulo-resumo-final {
  color: #4f2c19;
  text-align: left;
  font-size: 25px;
  font-family: "MontSerrat";
  font-weight: 700;
}

.subtitulo-resumo-final {
  color: #4F4C4D;
  text-align: left;
  font-family: "MontSerrat";
  font-size: 17px;
  font-weight: 600;
}

.titulo-conteudo-cabecalho {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 700;
  display: flex;
}

.label-cabecalho {
  color: #3E3E3E;
  text-align: left;
  font-family: 'MontSerrat';
  font-weight: 500;
}

.titulo-conteudo-resumo-final {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 700;
  margin-top: 15px;
}

.label-conteudo-resumo-final {
  color: #8A8A8A;
  text-align: left;
  font-family: "MontSerrat";
  margin-bottom: 10px;
}

.titulo-gerenciamento {
  color: #4f4c4d;
  text-align: left;
  font-size: 20px;
  font-family: "MontSerrat";
  font-weight: bold;
} 

/* PERÍODOS E DATAS */
.input-data {
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: 100%;
  grid-column-gap: 4%;
}

.data-inicio {
  grid-area: 1 / 1 / 2 / 2;
}

.data-periodo {
  color: #747474;
  font-family: Montserrat;
  grid-area: 1 / 2 / 2 / 3; 
  align-self: center;
}

.data-termino {
  grid-area: 1 / 3 / 2 / 4;
}

/* CHECKBOXES */
.input-checkbox {
  display: flex;
  padding-top: 3px;
  padding-bottom: 3px;
}

.label-checkbox {
  color: #8A8A8A;
  text-align: left;
  font-size: 15px;
  font-family: 'MontSerrat';
  margin-left: 5px;
}

/* POPUPS */
.titulo-popup {
  padding: 20px 0 15px;
  color: #3e3e3e;
  font-size: 16px;
  font-family: "MontSerrat";
  font-weight: bold;
}

.titulo-popup-finalizado {
  padding: 20px 0 15px;
  color: #3e3e3e;
  text-align: center;
  font-size: 16px;
  font-family: "MontSerrat";
  font-weight: bold;
}

.buttons-next-back, .buttons-next-back-popup {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  column-gap: 30px;
  row-gap: 10px;
  align-items: center;
  justify-content: center;
}

.button-next, .button-back {
  width: 14em;
}

.button-next-popup, .button-back-popup {
  width: 9em;
}

.botao-popup {
  width: 100%;
  display: flex;
  justify-content: center;
}

.botoes-popup {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 10px;
  align-items: center;
  justify-content: center;
}

.button-fechar-popup {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

/* INPUTS E BUTTONS - (AINDA ESTÃO EM TESTES) */
.input-label {
  width: 100%;
  margin-bottom: 5px;
}

.p-inputtext {
  width: 100%;
}

.p-dropdown {
  width: 100%;
}

.p-inputnumber {
  width: 100%;
}

.g-date-input {
  width: 100%;
}

.alinha-button-fluxo {
  margin: 50px 0 30px;
}

.buscar-button {
  display: flex;
  align-content: center;
  justify-content: center;
}


.buttons-next-back-popup {
  margin-top: 50px;
}

.linha-separacao {
  margin-top: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.button-fluxo {
  margin: 0 20px;
}

@media (min-width:310px) {
.buscar-button-header-filtro {
  display: none;
}

.buscar-button-filtro {
  display: flex;
  justify-content: center;
  align-items: self-end;
  margin-top: 30px;
}

.titulo-filtros-cabecalho {
  font-size: 18px;
}    

.titulo-inicio-fluxos {
  font-size: 22px;
}

.titulo-fluxos {
  font-size: 20px;
}

.titulo-conteudo-cabecalho {
  font-size: 15px;
  flex-direction: column;
  justify-content: flex-start;
}

.label-cabecalho {
  font-size: 14px;
}

.espacamento-filtros {
  margin: 20px 0;
}

.espacamento-fluxos {
  padding: 0 20px 25px;
}

.espacamento-inicio-fluxos {
  padding: 0 20px 25px;
}

.espacamento-header-resumo-final {
  padding: 20px 10px 0;
}

.espacamento-resumo-final {
  padding: 0 10px;
}

.titulo-grupo-detalhes {
  font-size: 18px;
}

.titulo-grupo-formulario {
  font-size: 18px;
}

.buttons-next-back {
  margin: 50px 20px 0;
}

.button-back-popup {
  width: 100%;
}

.button-next-popup {
  width: 100%;
}

.botoes-popup {
  flex-direction: column-reverse;
}
}

@media (min-width:368px) {
.titulo-conteudo-cabecalho {
  font-size: 16px;
  flex-direction: row;
  align-items: self-end;
}

.label-conteudo-resumo-final {
  font-size: 15px;
}
}

@media (min-width:400px) {
.espacamento-fluxos {
  padding: 0 25px 25px;
}

.espacamento-inicio-fluxos {
  padding: 0 25px 25px;
}

.espacamento-header-resumo-final {
  padding: 20px 15px 0;
}

.espacamento-resumo-final {
  padding: 0 15px;
}

.alinha-button-fluxo {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-fluxo {
  width: 15em;
}
}

@media (min-width:500px) {
}

@media (min-width:600px) {
.titulo-filtros-cabecalho {
  font-size: 20px;
}

.titulo-conteudo-cabecalho {
  font-size: 17px;
}

.label-cabecalho {
  font-size: 15px;
}

.espacamento-inicio-fluxos {
  padding: 0 50px 25px;
}

.espacamento-header-resumo-final {
  padding: 30px 20px 0;
}

.espacamento-resumo-final {
  padding: 0 20px;
}

.buscar-button-header-filtro {
  display: block;
}

.buscar-button-filtro {
  display: none;
}

.titulo-grupo-formulario {
  font-size: 19px;
}

.button-back, .button-next {
  width: 15em; 
}

.button-back-popup {
  grid-area: 1 / 1 / 2 / 2;
  justify-self: flex-end;
  width: 9em;
}

.button-next-popup {
  grid-area: 1 / 2 / 2 / 3;
  justify-self: flex-start;
  width: 9em;
}
}

@media (min-width:650px) {
.botoes-popup {
  flex-direction: row;
}
}

@media (min-width:801px) {
.titulo-filtros-cabecalho {
  font-size: 22px;
}  

.espacamento-filtros {
  margin: 20px 20px 0 20px;
}

.espacamento-inicio-fluxos {
  padding: 0 90px 25px;
}

.espacamento-detalhes {
  padding: 0 30px;
}

.checkbox-filtros {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  column-gap: 20px;
  row-gap: 2px;
}

.button-back-popup, .button-next-popup { 
  width: 12em;
}
}

@media (min-width:1025px) { 
.titulo-grupo-detalhes {
  font-size: 19px;
}

.titulo-inicio-fluxos {
  font-size: 23px;
}

.label-cabecalho {
  font-size: 15px;
}

.espacamento-detalhes {
  padding: 0 50px;
}

.espacamento-fluxos {
  padding: 0 50px 25px;
}

.espacamento-inicio-fluxos {
  padding: 0 18%;
}

.espacamento-header-resumo-final {
  padding: 30px 30px 0;
}

.espacamento-resumo-final {
  padding: 0 30px;
}
}

@media (min-width:1281px) { 
.titulo-fluxos {
  font-size: 21px;
}

.espacamento-fluxos {
  padding: 0 130px 25px;
}

.espacamento-inicio-fluxos {
  padding: 0 22% 25px;
}
}

@media (min-width:1500px) {
.titulo-fluxos {
  font-size: 22px;
}

.espacamento-fluxos {
  padding: 0 15% 25px;
}

.espacamento-inicio-fluxos {
  padding: 0 24% 25px;
}
}

@media (min-width:1800px) {
.label-cabecalho {
  font-size: 16px;
}

.espacamento-fluxos {
  padding: 0 18% 25px;
}

.espacamento-inicio-fluxos {
  padding: 0 28% 25px;
}
}

@media (min-width:2000px) {
.espacamento-fluxos {
  padding: 0 20% 25px;
}

.espacamento-inicio-fluxos {
  padding: 0 32% 25px;
}
}

@media (min-width:2000px) {
.titulo-resumo-final {
    font-size: 32px;
}
.subtitulo-resumo-final {
    font-size: 20px;
}

.titulo-conteudo-cabecalho {
  font-size: 22px;
}
.label-cabecalho {
  font-size: 20px;
}
}
</style>
